import React, { PropsWithChildren } from 'react';

import { Visibility } from 'components/Visibility';
import { Column, Row } from '../Layout/Grid';
import CDCloseButton from '../CDCloseButton';
import Text from '../Text';

import { IModal } from './interface';

const Modal: React.FC<PropsWithChildren<IModal>> = (props) => {

  const { width, height, className, title, onCloseAction, children, minWidth = "min-w-30", showCloseButton = false, borderRadius } = props;

  return (
    <div className="bg-modal fixed z-999 top-0 right-0 bottom-0 left-0 d-flex flex-column justify-center align-center">
      <Column
        className={`animated slideInDown relative max-w-100 max-h-100 bg-white ${minWidth} p-2 ${className || ''
          }`}
        style={{
          width,
          height,
          borderRadius: borderRadius || '0px 0px 0 0',
        }}
      >
        <Row className='align-center justify-between'>
          <Row>
            <Text size={24} className="color-primary font-bold">
              {title}
            </Text>
          </Row>

          <Visibility visible={showCloseButton}>
            <Row style={{ justifyContent: "flex-end" }}><CDCloseButton onClick={onCloseAction} /></Row>
          </Visibility>

        </Row>
        {children}
      </Column>
    </div>
  );
};

export default Modal;
